import script from "./MemberLink.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberLink.vue?vue&type=script&setup=true&lang=js"

import "./MemberLink.vue?vue&type=style&index=0&id=9e4a6cbc&lang=css"

const __exports__ = script;

export default __exports__